/**
 *  @class
 *  @function RemoveAll
 */
if (!customElements.get('remove-all')) {
  class RemoveAll extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      if (!this.hasAttribute('role')) {
        this.setAttribute('role', 'button');
      }
      if (!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', '0');
      }
      this.debouncedOnSubmit = debounce(() => {
        this.onSubmitHandler();
      }, 200);
      this.addEventListener('click', this.debouncedOnSubmit.bind(this));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.debouncedOnSubmit();
        }
      });
    }
    onSubmitHandler() {
      this.classList.add('loading');

      const noteInput = document.getElementById('mini-cart__notes');
      const bodyPayload = noteInput ? { note: noteInput.value } : {};

      fetch(`${theme.routes.cart_clear_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify(bodyPayload)
      })
        .then(() => {
          this.classList.remove('loading');
          this.drawer.refresh();
        })
        .catch(() => {
          this.classList.remove('loading');
        });
    }
  }
  customElements.define('remove-all', RemoveAll);
}